import Vue from 'vue';
import VueAnime from 'vue-animejs';
import App from './App.vue';
import router from './router';
import store from './store';

// scss
import './styles/app.scss';
import Icon from './components/Icon';
import Counter from './components/Counter';

Vue.config.productionTip = false;
Vue.component('icon', Icon);
Vue.component('counter', Counter);

Vue.use(VueAnime);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
